import { createFileRoute, redirect } from '@tanstack/react-router';
import { fetchAuthSession } from 'aws-amplify/auth';

import { SignInForm } from '@/features/auth/components/signInForm';

export const Route = createFileRoute('/internal/login')({
  component: Login,
  loader: async () => {
    const session = await fetchAuthSession();
    // @TODO Here we should check if the user has completed onboarding
    if (session.tokens) {
      throw redirect({
        to: '/onboarding',
      });
    }
  },
});

function Login() {
  return (
    <div className="flex h-full w-full items-center justify-center p-4">
      <SignInForm />
    </div>
  );
}
